import { adminModuleRegistry } from './adminModuleRegistry'
import { AdminModuleShell } from './AdminShared'

export function AdminSection({ apiToken, auctionRows, bidRows, consignmentRows, listingRows, onExportCsv, onRefresh, section, onSectionChange, orderRows, userRows }) {
  const module = adminModuleRegistry[section] || adminModuleRegistry.settings
  const moduleProps = { apiToken, auctionRows, bidRows, consignmentRows, listingRows, onExportCsv, onRefresh, onSectionChange, orderRows, userRows }

  return (
    <AdminModuleShell module={module}>
      {module.render(moduleProps)}
    </AdminModuleShell>
  )
}
